export default function DeafFundNotice({ compact = false }) {
    return (
        <div className={`w-full bg-white relative z-10 ${compact ? 'shadow-2xl rounded-3xl overflow-hidden border border-blue-100 h-full' : 'pt-0 pb-6 -mt-1'}`}>

            {/* Header */}
            <div className="w-full bg-blue-700 text-white py-3 px-6 shadow-md">
                <h2 className="text-lg sm:text-xl font-bold tracking-wide">
                    Notice Board
                </h2>
            </div>

            {/* Notice Box */}
            <div className={`px-6 py-4 space-y-4 ${compact ? 'h-[500px] overflow-y-auto custom-scrollbar' : ''}`}>
                
                {/* Notice: eTender Period Extension Notice (NIT No. 04 of 2026-27) */}
                <div className="border border-blue-400 bg-blue-50 rounded-xl p-5 shadow-sm hover:shadow-md transition-all duration-300">
                    <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-4">
                        <div className="flex items-start gap-4">
                             <div className="h-4 w-4 bg-red-600 rounded-full animate-pulse shrink-0 mt-1"></div>
                             <div>
                                 <p className="text-lg sm:text-xl font-semibold text-blue-900 leading-snug">
                                     eTender Period Extension Notice (NIT No. 04 of 2026-27)
                                 </p>
                                 <div className="flex items-center gap-2.5 mt-1">
                                     <p className="text-xs text-blue-800/80 font-semibold">Dated: 25-08-2026</p>
                                     <span className="text-[9px] tracking-wider font-extrabold bg-red-600 text-white px-2 py-0.5 rounded shadow-sm">
                                         EXTENSION
                                     </span>
                                 </div>
                             </div>
                        </div>
                        <div className="flex items-center gap-3 shrink-0 self-end sm:self-start sm:mt-0.5">
                            <button
                                onClick={() => window.open("/pdfs/eTender Notice_ADV_NIT.pdf", "_blank")}
                                className="text-xs font-bold bg-blue-700 hover:bg-blue-800 text-white px-4 py-2 rounded-lg shadow transition-colors"
                            >
                                View PDF
                            </button>
                            <a
                                href="/pdfs/eTender Notice_ADV_NIT.pdf"
                                download="eTender Notice_ADV_NIT.pdf"
                                className="text-xs font-bold bg-white border border-blue-300 hover:bg-blue-50 text-blue-700 px-4 py-2 rounded-lg shadow transition-colors flex items-center gap-1.5"
                            >
                                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"></path>
                                </svg>
                                Download
                            </a>
                        </div>
                    </div>
                    <p className="text-sm text-black/70 mt-3 pl-8 leading-relaxed">
                        The period of E-Tender (NIT No. 04 of 2026-27 dated 13-08-2026) relating to Concurrent Audit for the year 2026-27 of Murshidabad District Central Co-operative Bank Ltd. has been extended upto 27-08-2026 at 12.00 noon a.m. Date of opening of E-Tender is 28-08-2026 at 11.00 a.m. Collect all other details from website – https://www.tenderwizard.com/eproc
                    </p>
                </div>

                {/* Notice: NIQ Period Extension Notice (NIQ No. 02 of 2026-27) */}
                <div className="border border-blue-400 bg-blue-50 rounded-xl p-5 shadow-sm hover:shadow-md transition-all duration-300">
                    <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-4">
                        <div className="flex items-start gap-4">
                             <div className="h-4 w-4 bg-red-600 rounded-full animate-pulse shrink-0 mt-1"></div>
                             <div>
                                 <p className="text-lg sm:text-xl font-semibold text-blue-900 leading-snug">
                                     NIQ Period Extension Notice (NIQ No. 02 of 2026-27)
                                 </p>
                                 <div className="flex items-center gap-2.5 mt-1">
                                     <p className="text-xs text-blue-800/80 font-semibold">Dated: 05-08-2026</p>
                                     <span className="text-[9px] tracking-wider font-extrabold bg-red-600 text-white px-2 py-0.5 rounded shadow-sm">
                                         EXTENSION
                                     </span>
                                 </div>
                             </div>
                        </div>
                        <div className="flex items-center gap-3 shrink-0 self-end sm:self-start sm:mt-0.5">
                            <button
                                onClick={() => window.open("/pdfs/NIQ_ADV_NIT 02 of 2026-27 DT 230726_period extension.pdf", "_blank")}
                                className="text-xs font-bold bg-blue-700 hover:bg-blue-800 text-white px-4 py-2 rounded-lg shadow transition-colors"
                            >
                                View PDF
                            </button>
                            <a
                                href="/pdfs/NIQ_ADV_NIT 02 of 2026-27 DT 230726_period extension.pdf"
                                download="NIQ_ADV_NIT 02 of 2026-27 DT 230726_period extension.pdf"
                                className="text-xs font-bold bg-white border border-blue-300 hover:bg-blue-50 text-blue-700 px-4 py-2 rounded-lg shadow transition-colors flex items-center gap-1.5"
                            >
                                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"></path>
                                </svg>
                                Download
                            </a>
                        </div>
                    </div>
                    <p className="text-sm text-black/70 mt-3 pl-8 leading-relaxed">
                        The period of NIQ No. 02 of 2026-27 dated 28-07-2026 relating to AMC for Cash Counting Fake Note Detection Machine and Bundle Counting Machine of various branches (19 nos.) in the district of Murshidabad during the year 2026-27, for the period of 01-08-2026 to 31-07-2027 of Murshidabad District Central Co-operative Bank Ltd. has been extended upto 11-08-2026 at 11.59 a.m. Date of opening of NIQ is 12-08-2026 at 11.00 a.m. Details information on abovementioned works will be available at MDCC Bank Ltd. Head Office, Berhampore, Murshidabad.
                    </p>
                </div>

                {/* Notice: Notice Inviting Quotation (NIQ No. 02 of 2026-27) */}
                <div className="border border-blue-400 bg-blue-50 rounded-xl p-5 shadow-sm hover:shadow-md transition-all duration-300">
                    <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-4">
                        <div className="flex items-start gap-4">
                             <div className="h-4 w-4 bg-blue-700 rounded-full animate-pulse shrink-0 mt-1"></div>
                             <div>
                                 <p className="text-lg sm:text-xl font-semibold text-blue-900 leading-snug">
                                     Notice Inviting Quotation (NIQ No. 02 of 2026-27)
                                 </p>
                                 <div className="flex items-center gap-2.5 mt-1">
                                     <p className="text-xs text-blue-800/80 font-semibold">Dated: 28-07-2026</p>
                                     <span className="text-[9px] tracking-wider font-extrabold bg-blue-600 text-white px-2 py-0.5 rounded shadow-sm">
                                         NEW
                                     </span>
                                 </div>
                             </div>
                        </div>
                        <div className="flex items-center gap-3 shrink-0 self-end sm:self-start sm:mt-0.5">
                            <button
                                onClick={() => window.open("/pdfs/NIQ 02 of 26-27 DT 230726_SHORT.pdf", "_blank")}
                                className="text-xs font-bold bg-blue-700 hover:bg-blue-800 text-white px-4 py-2 rounded-lg shadow transition-colors"
                            >
                                View PDF
                            </button>
                            <a
                                href="/pdfs/NIQ 02 of 26-27 DT 230726_SHORT.pdf"
                                download="NIQ 02 of 26-27 DT 230726_SHORT.pdf"
                                className="text-xs font-bold bg-white border border-blue-300 hover:bg-blue-50 text-blue-700 px-4 py-2 rounded-lg shadow transition-colors flex items-center gap-1.5"
                            >
                                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"></path>
                                </svg>
                                Download
                            </a>
                        </div>
                    </div>
                    <p className="text-sm text-black/70 mt-3 pl-8 leading-relaxed">
                        Notice Inviting Quotations are invited from the interested eligible parties for AMC for Cash Counting Fake Note Detection Machine and Bundle Counting Machine of various branches (19 nos.) in the district of Murshidabad during the year 2026-27, for the period of 01-08-2026 to 31-07-2027 of Murshidabad District Central Co-operative Bank Ltd. as per bank's specification, requisitions, terms & conditions. Last date of receiving quotation is 03-08-2026 at 11.59 p.m.
                    </p>
                </div>

                {/* Notice: eTender Extension Notice (NIT No. 03 of 2026-27) */}
                <div className="border border-blue-400 bg-blue-50 rounded-xl p-5 shadow-sm hover:shadow-md transition-all duration-300">
                    <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-4">
                        <div className="flex items-start gap-4">
                             <div className="h-4 w-4 bg-red-600 rounded-full animate-pulse shrink-0 mt-1"></div>
                             <div>
                                 <p className="text-lg sm:text-xl font-semibold text-blue-900 leading-snug">
                                     eTender Period Extension Notice (NIT No. 03 of 2026-27)
                                 </p>
                                 <div className="flex items-center gap-2.5 mt-1">
                                     <p className="text-xs text-blue-800/80 font-semibold">Dated: 23-07-2026</p>
                                     <span className="text-[9px] tracking-wider font-extrabold bg-red-600 text-white px-2 py-0.5 rounded shadow-sm">
                                         EXTENSION
                                     </span>
                                 </div>
                             </div>
                        </div>
                        <div className="flex items-center gap-3 shrink-0 self-end sm:self-start sm:mt-0.5">
                            <button
                                onClick={() => window.open("/pdfs/eTender Notice_ADV_NIT 03 of 2026-27_EXTENSION.pdf", "_blank")}
                                className="text-xs font-bold bg-blue-700 hover:bg-blue-800 text-white px-4 py-2 rounded-lg shadow transition-colors"
                            >
                                View PDF
                            </button>
                            <a
                                href="/pdfs/eTender Notice_ADV_NIT 03 of 2026-27_EXTENSION.pdf"
                                download="eTender Notice_ADV_NIT 03 of 2026-27_EXTENSION.pdf"
                                className="text-xs font-bold bg-white border border-blue-300 hover:bg-blue-50 text-blue-700 px-4 py-2 rounded-lg shadow transition-colors flex items-center gap-1.5"
                            >
                                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"></path>
                                </svg>
                                Download
                            </a>
                        </div>
                    </div>
                    <p className="text-sm text-black/70 mt-3 pl-8 leading-relaxed">
                        The period of E-Tender (NIT No. 03 of 2026-27 dated 09-07-2026) relating to supply, installation, testing, and commissioning of B-Type Locker Room Door (SRD with grill gate and Air Ventilator) for the Bank's branch premises of Lalbagh Branch (new building) situated at Jiaganj, Murshidabad for the year 2026-27 of Murshidabad District Central Co-operative Bank Ltd. has been extended upto 28-07-2026 at 11.59 a.m. Date of opening of E-Tender is 29-07-2026 at 11.00 a.m.
                    </p>
                </div>

                {/* Notice: eTender Notice (NIT No. 03 of 2026-27) */}
                <div className="border border-blue-300 bg-blue-50/50 rounded-xl p-5 shadow-sm hover:shadow-md transition-all duration-300">
                    <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-4">
                        <div className="flex items-start gap-4">
                             <div className="h-4 w-4 bg-blue-700 rounded-full animate-pulse shrink-0 mt-1"></div>
                             <div>
                                 <p className="text-lg sm:text-xl font-semibold text-blue-900 leading-snug">
                                     eTender Notice (NIT No. 03 of 2026-27)
                                 </p>
                                 <div className="flex items-center gap-2.5 mt-1">
                                     <p className="text-xs text-blue-800/80 font-semibold">Dated: 09-07-2026</p>
                                     <span className="text-[9px] tracking-wider font-extrabold bg-blue-600 text-white px-2 py-0.5 rounded shadow-sm">
                                         NEW
                                     </span>
                                 </div>
                             </div>
                        </div>
                        <div className="flex items-center gap-3 shrink-0 self-end sm:self-start sm:mt-0.5">
                            <button
                                onClick={() => window.open("/pdfs/eTender Notice_ADV_NIT 03 of 2026-27_SHORT.pdf", "_blank")}
                                className="text-xs font-bold bg-blue-700 hover:bg-blue-800 text-white px-4 py-2 rounded-lg shadow transition-colors"
                            >
                                View PDF
                            </button>
                            <a
                                href="/pdfs/eTender Notice_ADV_NIT 03 of 2026-27_SHORT.pdf"
                                download="eTender Notice_ADV_NIT 03 of 2026-27_SHORT.pdf"
                                className="text-xs font-bold bg-white border border-blue-300 hover:bg-blue-50 text-blue-700 px-4 py-2 rounded-lg shadow transition-colors flex items-center gap-1.5"
                            >
                                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"></path>
                                </svg>
                                Download
                            </a>
                        </div>
                    </div>
                    <p className="text-sm text-black/60 mt-3 pl-8 leading-relaxed">
                        Supply, installation, testing and commissioning of B-Type Locker Room Door (SRD with grill gate and Air Ventilator) for Lalbagh Branch (new building)
                    </p>
                </div>

                {/* Notice 0: Notice Inviting Quotation */}
                <div className="border border-blue-300 bg-blue-50/50 rounded-xl p-5 shadow-sm hover:shadow-md transition-all duration-300">
                    <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-4">
                        <div className="flex items-start gap-4">
                            <div className="h-4 w-4 bg-blue-700 rounded-full animate-pulse shrink-0 mt-1"></div>
                            <div>
                                <p className="text-lg sm:text-xl font-semibold text-blue-900 leading-snug">
                                    Notice Inviting Quotation (NIQ No. 01 of 2026-27)
                                </p>
                                <div className="flex items-center gap-2.5 mt-1">
                                    <p className="text-xs text-blue-800/80 font-semibold">Dated: 24-06-2026</p>
                                    <span className="text-[9px] tracking-wider font-extrabold bg-blue-600 text-white px-2 py-0.5 rounded shadow-sm">
                                        NEW
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="flex items-center gap-3 shrink-0 self-end sm:self-start sm:mt-0.5">
                            <button
                                onClick={() => window.open("/pdfs/Notice_Inviting_Quotation_Lalbagh_Branch.pdf", "_blank")}
                                className="text-xs font-bold bg-blue-700 hover:bg-blue-800 text-white px-4 py-2 rounded-lg shadow transition-colors"
                            >
                                View PDF
                            </button>
                            <a
                                href="/pdfs/Notice_Inviting_Quotation_Lalbagh_Branch.pdf"
                                download="Notice_Inviting_Quotation_Lalbagh_Branch.pdf"
                                className="text-xs font-bold bg-white border border-blue-300 hover:bg-blue-50 text-blue-700 px-4 py-2 rounded-lg shadow transition-colors flex items-center gap-1.5"
                            >
                                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"></path>
                                </svg>
                                Download
                            </a>
                        </div>
                    </div>
                    <p className="text-sm text-black/60 mt-3 pl-8 leading-relaxed">RCC wall with vault gate settings of Lalbagh Branch</p>
                </div>

                {/* Notice 1 */}
                <div
                    className="border border-blue-200 bg-white hover:bg-blue-50/10
                     rounded-xl p-5 flex flex-col sm:flex-row sm:items-center justify-between gap-4
                     shadow-sm hover:shadow-md transition-all duration-300"
                >
                    <div className="flex items-center gap-4">
                        <div className="h-4 w-4 bg-blue-600 rounded-full animate-pulse"></div>
                        <div>
                            <p className="text-lg sm:text-xl font-semibold text-blue-900">
                                eTender Notice (ADV_NIT 01 of 2026-27)
                            </p>
                            <p className="text-sm text-black/60">Click below to view or download the tender notice PDF</p>
                        </div>
                    </div>
                    <div className="flex items-center gap-3">
                        <button
                            onClick={() => window.open("/pdfs/eTender Notice_ADV_NIT 01 of 2026-27.pdf", "_blank")}
                            className="text-xs font-bold bg-blue-700 hover:bg-blue-800 text-white px-4 py-2 rounded-lg shadow transition-colors"
                        >
                            View PDF
                        </button>
                        <a
                            href="/pdfs/eTender Notice_ADV_NIT 01 of 2026-27.pdf"
                            download="eTender_Notice_ADV_NIT_01_of_2026-27.pdf"
                            className="text-xs font-bold bg-white border border-blue-300 hover:bg-blue-50 text-blue-700 px-4 py-2 rounded-lg shadow transition-colors flex items-center gap-1.5"
                        >
                            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"></path>
                            </svg>
                            Download
                        </a>
                    </div>
                </div>

                {/* Notice 2 */}
                <div
                    onClick={() => window.open("/pdfs/DEAF_FUND_2025.pdf", "_blank")}
                    className="cursor-pointer border border-blue-200 bg-white hover:bg-blue-50/10
                     rounded-xl p-5 flex items-center justify-between
                     shadow-sm hover:shadow-md transition-all duration-300"
                >
                    <div className="flex items-center gap-4">
                        <div className="h-4 w-4 bg-blue-400 rounded-full"></div>
                        <div>
                            <p className="text-lg sm:text-xl font-semibold text-blue-900">
                                DEAF FUND DETAILS
                            </p>
                            <p className="text-sm text-black/60">Click to open PDF</p>
                        </div>
                    </div>
                </div>

                {/* Notice 3 */}
                <div
                    className="cursor-pointer border border-blue-200 bg-white hover:bg-blue-50/10
                     rounded-xl p-5 flex items-center justify-between
                     shadow-sm hover:shadow-md transition-all duration-300"
                >
                    <div className="flex items-center gap-4">
                        <div className="h-4 w-4 bg-blue-400 rounded-full"></div>
                        <div>
                            <p className="text-lg font-semibold text-blue-900">
                                KYC Update Guidelines
                            </p>
                            <p className="text-sm text-black/60">Mandatory for all savings accounts</p>
                        </div>
                    </div>
                </div>

                {/* Notice 4 */}
                <div
                    className="cursor-pointer border border-blue-200 bg-white hover:bg-blue-50/10
                     rounded-xl p-5 flex items-center justify-between
                     shadow-sm hover:shadow-md transition-all duration-300"
                >
                    <div className="flex items-center gap-4">
                        <div className="h-4 w-4 bg-blue-400 rounded-full"></div>
                        <div>
                            <p className="text-lg font-semibold text-blue-900">
                                Holiday Notice
                            </p>
                            <p className="text-sm text-black/60">Branches will remain closed on 2nd Saturdays</p>
                        </div>
                    </div>
                </div>
                
                 {/* Notice 5 */}
                 <div
                    className="cursor-pointer border border-blue-200 bg-white hover:bg-blue-50/10
                     rounded-xl p-5 flex items-center justify-between
                     shadow-sm hover:shadow-md transition-all duration-300"
                >
                    <div className="flex items-center gap-4">
                        <div className="h-4 w-4 bg-blue-400 rounded-full"></div>
                        <div>
                            <p className="text-lg font-semibold text-blue-900">
                                Locker Facility Available
                            </p>
                            <p className="text-sm text-black/60">Contact your nearest branch for details</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}
